<template>

  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> Button </v-btn> -->

      <v-btn
        v-on="tooltip != null ? on : null"
        v-bind="attrs"
        :class="classAttr"
        v-if="accessAllow"
        :fab="fab"
        :dark="dark"
        :small="small"
        :color="color"
        @click="click"
        :icon="icon != null"
        :rounded="rounded"
        :outlined="outlined"
        :disabled="disabled"
        :elevation="appbar == null ? null : 0"
      >
        {{ label }}
        <slot></slot>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

</template>

<script>
export default {
  props: [
    'classAttr',
    "tooltip",
    "label",
    "access",
    "color",
    "outlined",
    "icon",
    "rounded",
    "disabled",
    "appbar",
    "fab",
    "dark",
    "small",
  ],
  name: "btn-a",
  data() {
    return { accessAllow: true };
  },
  computed: {},
  methods: {
    click() {
      this.$emit("click");
    },
    async accessAllowed() {
      if (!this.access) return true;
      return await this.$auth.claimExist(this.access);
    },
  },
  async mounted() {
    this.accessAllow = await this.accessAllowed();
  },
};
</script>
